import { DailySiteReportIneligibleReason } from '@models/dailySiteReport.model';

/** Sprint 38, story-207 (D3). Code -> translated copy; the raw backend message is never shown. */
export interface DailySiteReportErrorStrings {
  sendNowError: string;
  errorNotEligible: string;
  errorNotConfigured: string;
  errorQuotaExceeded: string;
  ineligibleNoRole: string;
  ineligibleClientNoActivityAccess: string;
  ineligibleClientNoLinkedClient: string;
}

/** The GraphQL error code carried on a failed request, if any. */
export const errorCodeOf = (error: unknown): string | undefined =>
  (error as { response?: { errors?: { extensions?: { code?: string } }[] } })?.response?.errors?.[0]?.extensions?.code;

/** One string for a failed send-now: a mapped code, else the generic fallback. */
export function errorMessageFor(code: string | undefined | null, t: DailySiteReportErrorStrings): string {
  switch (code) {
    case 'DAILY_SITE_REPORT_NOT_ELIGIBLE':
      return t.errorNotEligible;
    case 'DAILY_SITE_REPORT_NOT_CONFIGURED':
      return t.errorNotConfigured;
    case 'DAILY_SITE_REPORT_QUOTA_EXCEEDED':
      return t.errorQuotaExceeded;
    default:
      return t.sendNowError;
  }
}

/**
 * The reason line shown under the disabled "Send me today's report" button. An unknown code, or
 * `eligible === false` with no reason, uses the generic "not available" line.
 */
export function ineligibleReasonMessage(
  reason: DailySiteReportIneligibleReason | string | null | undefined,
  t: DailySiteReportErrorStrings,
): string {
  switch (reason) {
    case 'NO_ROLE':
      return t.ineligibleNoRole;
    case 'CLIENT_NO_ACTIVITY_ACCESS':
      return t.ineligibleClientNoActivityAccess;
    case 'CLIENT_NO_LINKED_CLIENT':
      return t.ineligibleClientNoLinkedClient;
    default:
      return t.errorNotEligible;
  }
}
